import React from 'react'
import moment from 'moment'
import 'moment-timezone'
import Tooltip from '../Tooltip'
import ChecklistTooltip from './tooltips/ChecklistTooltip'

export default class ChecklistCheckbox extends React.Component {
  constructor(props) {
    super(props)

    const { checklist, name, internalNotes } = props
    this.state = { checked: checklist[name], internalNotes: internalNotes }
  }

  handleClick = () => {
    const { name, label, checklist, adminUser } = this.props
    const internalNotes = this.props.internalNotes == null ? '' : this.props.internalNotes + '\n'
    const val = !this.state.checked

    const time = moment().tz('America/Chicago').format('M/D LT z')
    const additionalNote = `${time} - ${label} ${val === true ? 'complete' : 'incomplete'} (${adminUser.name})`
    const notesText = val !== checklist[name] ? internalNotes + additionalNote : internalNotes
    this.setState({ checked: val, internalNotes: notesText })
  }

  handleChange = (data) => {
    this.setState({ internalNotes: data })
  }

  handleSubmit = (e) => {
    e.preventDefault()
    const { order, name, handleSubmit } = this.props
    const { internalNotes, checked } = this.state
    handleSubmit(order, internalNotes, { [name]: checked })
  }

  handleCancel = () => {
    const { checklist, name } = this.props
    // TODO: this is a hack for closing the tooltip.  This component should manage this.
    this.props.closeTooltip()
    this.setState({ checked: checklist[name] })

  }

  render() {
    const { name } = this.props
    const { checked, internalNotes } = this.state
    const checkbox = (
      <input
        type="checkbox"
        name={name}
        onChange={this.handleClick}
        checked={this.state.checked}
        style={{cursor: 'pointer'}}
      />
    )
    return (
      <Tooltip
        trigger={checkbox}
        content={
          <ChecklistTooltip
            name={name}
            checked={checked}
            handleChange={this.handleChange}
            handleSubmit={this.handleSubmit}
            handleCancel={this.handleCancel}
            internalNotes={internalNotes}
          />
        }
      />
    )
  }
}
